/*
 * @Author: your name
 * @Date: 2022-03-07 16:29:48
 * @LastEditTime: 2022-10-25 11:00:14
 * @LastEditors: pyx 3245266940@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \wx-front\src\utils\api\contractAPI.js
 */
import http from '../http'
import httpT from '../httpT'
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */


// 获取签名列表
export function getSignatureListAPI(params){
    return http.get(`/crm/wx/parent/handwritten/signature/list`,params)
}
// 添加手写签名
export function postSignatureAPI(params){
    return http.post(`/crm/wx/parent/handwritten/signature`,params)
}
// 删除某些签名
export function deleteSignatureAPI(params){
    return http.delete(`/crm/wx/parent/handwritten/signature`,params)
}
// 获取合同列表
export function getContractListAPI(params){
    return http.get(`/crm/wx/parent/contract/list`,params)
}
//获取合同详情
export function getContractDetailAPI(params){
    return http.get(`/crm/wx/parent/contract`,params)
}
//更新合同状态/拒绝签署
export function putRejectContractAPI(params){
    return http.put(`/crm/wx/parent/contract/status`,params)
}
// //更新合同信息/签署合同
export function putSigningContractAPI(params){
    return http.put(`/crm/wx/parent/contract/signing`,params)
}

// 检查验证码是否正确
export function postCheckVerifyCodeAPI(params){
    return http.post(`/rbac/wx/openapi/verify/code/check`,params)
}